import { Router } from "@angular/router";
import { ProductDetail } from "./../../../model/products.model";
import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { ProductsService } from "src/app/services/products.service";
import {
  MatPaginator,
  MatSort,
  MatTableDataSource,
  PageEvent,
} from "@angular/material";
import { AuthService } from "src/app/services";

@Component({
  selector: "app-list",
  templateUrl: "./list.component.html",
  styleUrls: ["./list.component.scss"],
})
export class ListComponent implements OnInit, AfterViewInit {
  pageIndex: number = 0;
  pageSize: number = 10;
  totalResult: number = 0;
  totalPage: number = 0;
  products: ProductDetail[] = [];
  pageSizeOptions: number[] = [5, 10, 25, 100];

  displayedColumns: string[] = [
    "index",
    "update",
    "title",
    "summary",
    "content",
    "category",
    "enable",
  ];

  dataSource = new MatTableDataSource<ProductDetail>();
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    private productService: ProductsService,
    private router: Router,
  ) {
  }

  ngAfterViewInit(): void {
    this.dataSource.sortingDataAccessor = (item, property) => {
      switch (property) {
        case "category":
          return item.category.name;
        default:
          return item[property];
      }
    };
  }

  ngOnInit() {
    this.search();
  }

  search() {
    this.productService
      .getAllProduct(this.pageIndex + 1, this.pageSize)
      .subscribe((result) => {
        this.totalPage = result.totalPage;
        this.totalResult = result.totalResult;

        this.dataSource.data = result.data;
        this.dataSource.sort = this.sort;
      });
  }

  delete(productDetail: ProductDetail) {}
  update(productDetail: ProductDetail) {
    this.router.navigate(["product", productDetail.id]);
  }
  displayStatusChange(status: boolean) {
    if (status) {
      return "Deactivate";
    } else {
      return "Activate";
    }
  }
  toggleStatus(productDetail: ProductDetail) {
    this.productService.toggleStatus(productDetail.id).subscribe((result) => {
      if (result) {
        this.search();
      }
    });
  }

  onPageChange(event: any) {
    if (this.pageSize !== event.pageSize) {
      this.pageIndex = 0;
      this.pageSize = event.pageSize;
    } else {
      this.pageIndex = event.pageIndex;
    }

    this.search();
  }
}
